import r from"@mui/material/generateUtilityClass";import t from"@mui/material/generateUtilityClasses";function i(t){return r("MuiMasonry",t)}t("MuiMasonry",["root"]);export{i as getMasonryUtilityClass};
//# sourceMappingURL=masonryClasses.js.map
